module.exports = __webpack_public_path__ + "img/apartment-architecture-bookcase-bookshelves-271816.7aa2a18c.jpg";